var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewAddIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 14,
    r: 13.5,
    fill: "#374DA0",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 15.3346C13.72 15.3346 10.1666 16.2213 10.1666 18.0013V19.3346H20.8333V18.0013C20.8333 16.2213 17.28 15.3346 15.5 15.3346ZM9.49996 12.668V10.668H8.16663V12.668H6.16663V14.0013H8.16663V16.0013H9.49996V14.0013H11.5V12.668M15.5 14.0013C16.2072 14.0013 16.8855 13.7204 17.3856 13.2203C17.8857 12.7202 18.1666 12.0419 18.1666 11.3346C18.1666 10.6274 17.8857 9.94911 17.3856 9.44902C16.8855 8.94892 16.2072 8.66797 15.5 8.66797C14.7927 8.66797 14.1144 8.94892 13.6143 9.44902C13.1142 9.94911 12.8333 10.6274 12.8333 11.3346C12.8333 12.0419 13.1142 12.7202 13.6143 13.2203C14.1144 13.7204 14.7927 14.0013 15.5 14.0013Z",
    fill: "#374DA0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewAddIcon);
export default __webpack_public_path__ + "static/media/newAddIcon.acfa45f22d8e736e2ba54b5419a98b40.svg";
export { ForwardRef as ReactComponent };